import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Showcase,
  Header,
  SectionTitle,
  Intro,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        complete={true}
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      >
        <Intro>
          <p>
            A button group is a type of form input that presents selectable
            options as buttons. Use as an alternative to{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/radio/develop'}
            >
              radio
            </Link>{' '}
            or{' '}
            <Link
              class="link"
              to={'/' + data.site + '/components/select/develop'}
            >
              select
            </Link>{' '}
            components with no more than four options.
          </p>
          <p>
            Button group classes are designed to be used with a{' '}
            <span class="inline__code">{'<div>'}</span>
            wrapped <span class="inline__code">{'<button>'}</span> element, but
            can also modify <span class="inline__code">{'<Intro>'}</span>{' '}
            wrapped
            <span class="inline__code">{'<a>'}</span> or{' '}
            <span class="inline__code">{'<input>'}</span> elements.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          title={data.title}
          text="Every button group displays both active and inactive options, indicated by the background color of the container. All options are inactive to start, and the user can only select one active option at a time. Active and inactive options each have three states: default, hover, and focus."
          code={code.buttonGroup}
        >
          <div
            class="c-button-group"
            role="group"
            aria-label="Button Group Example"
          >
            <button type="button" class="c-button-group__button--active">
              Left
            </button>
            <button type="button" class="c-button-group__button">
              Middle
            </button>
            <button type="button" class="c-button-group__button">
              Right
            </button>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}

export const code = {
  buttonGroup: `<div class="c-button-group" role="group" aria-label="Button Group Example">
  <button type="button" class="c-button-group__button--active">
    Button 1
  </button>
  <button type="button" class="c-button-group__button">
    Button 2
  </button>
  <button type="button" class="c-button-group__button">
    Button 3
  </button>
</div>
`,
}
